import { ALL_PERMISSION_KEYS, OLD_TO_NEW_PERMISSION_MAP, NEW_TO_OLD_PERMISSION_MAP } from "./permissions";
import { isProtectedAdministratorRole } from "./roleProtection";

export const PEOPLE_SETTINGS_PERMISSION = "people_access.manage_settings";
export const CREATE_WORKSPACES_PERMISSION = "workspaces.create";
export const OWNER_DELEGATED_PERMISSIONS = [PEOPLE_SETTINGS_PERMISSION, CREATE_WORKSPACES_PERMISSION] as const;
/** Only this confirmed workspace has approved the owner-only transition. */
export const OWNER_ONLY_SETTINGS_WORKSPACE_ID = "39d03333-7707-4e30-8340-79bf8260a857";
export const SENSITIVE_ACCESS_GROUPS = ["costs","suppliers","boxes","book","held","pay","personal","maintenance","sales"] as const;
export function permissionAliases(key: string): string[] {
  const found = new Set([key]);
  for (const next of OLD_TO_NEW_PERMISSION_MAP[key] || []) found.add(next);
  for (const next of NEW_TO_OLD_PERMISSION_MAP[key] || []) found.add(next);
  return [...found];
}
export function applyPersonalPermissions(base: string[], overrides: {permissionId:string;effect:string}[]) {
  const set = new Set(base);
  // Expand legacy grants first, then replace only the specifically selected
  // permission. Denying a broad legacy key deliberately denies its aliases.
  for (const key of base) for (const next of OLD_TO_NEW_PERMISSION_MAP[key] || []) set.add(next);
  const touched = new Set(overrides.flatMap(row => permissionAliases(row.permissionId)));
  for (const key of touched) set.delete(key);
  for (const row of overrides.filter(row => row.effect === "allow")) set.add(row.permissionId);
  return [...set];
}
export function allowance(limit:number|null,used:number) {
  return {limit,used,remaining:limit === null ? null : Math.max(0,limit-used)};
}
export function actorAllowance(role: {id?:string;name?:string|null}|null, limit:number|null, used:number) {
  return allowance(isProtectedAdministratorRole(role) ? null : limit, used);
}
export const PERMISSION_UNIVERSE = ALL_PERMISSION_KEYS;
